import { Component, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { NanoService } from 'src/app/shared/nano/nano.service';
import { AuthService } from 'src/app/shared/server-services/auth.service';
import { NanoSlotRecord } from 'src/app/shared/server-services/query-records/nano-records';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { RouterHandler } from 'src/app/shared/services/router-handler.service';
import { TitleService } from 'src/app/shared/services/title.service';

import { MatDialog } from '@angular/material/dialog';
import { base64 } from 'rfc4648';
import { NanoManagerDialogComponent } from 'src/app/shared/dialogs/nano-manager-dialog/nano-manager-dialog.component';
import { NANO_VERSION_FOR_BACKUP } from 'src/app/shared/drive-version';
import { RoomService } from 'src/app/shared/server-services/room.service';

@Component({
  selector: 'app-privy',
  templateUrl: './privy.component.html',
  styleUrl: './privy.component.scss',
})
export class PrivyComponent implements OnInit {
  public roomId;
  public nanoSlots: NanoSlotRecord[];
  private apiParams: {
    sk: Uint8Array;
    p1: Uint8Array;
    p4?: Uint8Array;
  };
  public requiredVersion = NANO_VERSION_FOR_BACKUP;

  constructor(
    private routerHandler: RouterHandler,
    private authService: AuthService,
    private dialogService: DialogService,
    private titleService: TitleService,
    private nanoService: NanoService,
    private roomService: RoomService,
    protected dialog: MatDialog
  ) {
    this.titleService.setCurrentTabTitle(marker('Private Backup Setup'));
  }

  ngOnInit(): void {
    let { sk, p1, p4 } = this.routerHandler.getRoute().fragment;
    if (sk && p1) {
      console.log('ok');
      try {
        this.apiParams = {
          sk: base64.parse(sk),
          p1: base64.parse(p1),
        };
        if (p4) {
          this.apiParams['p4'] = base64.parse(p4);
        }
      } catch (e) {
        this.dialogService.openAlertDialog(
          marker('Error'),
          marker('Wrong URL. Can not parse tokens.')
        );
        this.routerHandler.navigate(['/']);
        return;
      }
    } else {
      this.dialogService.openAlertDialog(
        marker('Error'),
        marker('Wrong URL. Some tokens are missing.')
      );
      this.routerHandler.navigate(['/']);
      return;
    }

    if (this.authService.isAnonym()) {
      this.dialogService.openAlertDialog(
        marker('Error'),
        marker('Please log in before accessing this page.')
      );
      this.routerHandler.navigate(['/login'], {
        fragment: this.routerHandler.fragmentToRaw({
          sk,
          p1,
          nav: 'privy/setup',
        }),
      });

      return;
    }
  }

  public backupSetupError = '';
  public backupSetupInProgress = false;
  public startBackup() {
    this.backupSetupInProgress = true;
    this.roomService
      .createPrivySetup(this.apiParams.sk, this.apiParams.p1, this.apiParams.p4)
      .then(async (roomId) => {
        this.roomId = roomId;
        this.backupSetupInProgress = false;
      })
      .catch(async (e) => {
        this.backupSetupError = e.message || 'error';
        this.backupSetupInProgress = false;
      });
  }

  public deletePrivy(roomId) {
    this.roomService
      .deletePrivyRoom(roomId)
      .then((res) => {
        console.log('res', res);
      })
      .catch((err) => {
        console.log('err', err);
      });
  }

  public openNanoManagerDialog(): void {
    this.dialog.open(NanoManagerDialogComponent, { autoFocus: false });
  }
}
